const REGION_DISPLAY_ORDER = ['usa', 'canada', 'india', 'thailand'] as const;

const REGION_DISPLAY_RANK = new Map<string, number>(
  REGION_DISPLAY_ORDER.map((slug, index) => [slug, index]),
);

export function orderRegions<T extends { slug: string }>(regions: readonly T[]): T[] {
  return [...regions].sort(
    (left, right) =>
      (REGION_DISPLAY_RANK.get(left.slug) ?? Number.MAX_SAFE_INTEGER) -
      (REGION_DISPLAY_RANK.get(right.slug) ?? Number.MAX_SAFE_INTEGER),
  );
}
